import React from "react";
import LogoMosyapay from "../../icon/LogoMosyapay";
import { useDarkMode } from "../../hooks/useDarkMode";

const LoadingPage = () => {
    useDarkMode();
    return (
        <div className="absolute left-0 z-50 h-screen w-full bg-opacity-10 backdrop-blur-lg bg-gradient-to-t from-yellow_m-200 to-orange-100 flex justify-center items-center dark:from-black_m-300 dark:to-black_m-200">
            <div className="p-5 bg-white_m-100 rounded-xl">
                <LogoMosyapay />
            </div>
        </div>
    );
};

export default LoadingPage;
